
<template>
    
        <mars-view class="header-box"><mars-view class="bg" :style="'background-image: url(' + info.header_link + ')'"></mars-view><mars-view class="radius-box"></mars-view><mars-view class="h-swiper-box"><ui-swiper v-if="swiperList.length" :swiper-list="swiperList"></ui-swiper></mars-view></mars-view>
    
</template>

<script>
import uiSwiper from "./uiSwiper.vue";
export default {
  components: {
    'ui-swiper': uiSwiper
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    swiperList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.header-box {
  position: relative;
}
.header-box .bg {
  position: relative;
  width: 100%;
  height: 82.28vw;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.header-box .radius-box {
  position: absolute;
  left: 0;
  top: 59.1vw;
  width: 13.2vw;
  height: 13.2vw;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/mapClue/radius-icon.png') no-repeat center / 100% 100%;
}
.header-box .h-swiper-box {
  position: absolute;
  z-index: 1;
  width: 100%;
  padding: 0 7.25vw;
  left: 0;
  bottom: 17.43vw;
  box-sizing: border-box;
}

</style>
